import SignIn from './SignIn'
import SignUp from './SignUp'
import AuthSwitch from './AuthSwitch'

export default AuthSwitch
export{SignIn, SignUp}